export default "__VITE_ASSET__YtNALcyn__"